import { render, staticRenderFns } from "./Tutorial.vue?vue&type=template&id=5b285150&scoped=true&lang=pug&"
import script from "./Tutorial.vue?vue&type=script&lang=ts&"
export * from "./Tutorial.vue?vue&type=script&lang=ts&"
import style0 from "./Tutorial.vue?vue&type=style&index=0&id=5b285150&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b285150",
  null
  
)

export default component.exports